import React from 'react';
import { useNavigate } from 'react-router-dom';
import HomeNavbar from './HomeNavbar';
import './Home.css';

import HomeImage from '../assets/pic1.jpg';

const Home = () => {
  const navigate = useNavigate();

  return (
    <div
      className="home-page"
      style={{
        backgroundImage: `url(${HomeImage})`,
      }}
    >
      <HomeNavbar />

      <div className="hero-section">
        <h1>Dilan Munasingha</h1>
        <p className="tagline">Photography</p>
        <p className="description">
          Rooted in fashion, guided by emotion every image a story !
        </p>

        <button
          className="view-work-btn"
          onClick={() => navigate('/portfolio')}
        >
          View My Work
        </button>
      </div>
    </div>
  );
};

export default Home;


